module.exports = {"pathContext":{"name":"EventsOrderBy","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"insertedAt","type":{"kind":"ENUM","name":"OrderByDirection","ofType":null}},{"defaultValue":null,"description":null,"name":"type","type":{"kind":"ENUM","name":"OrderByDirection","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-events-order-by.json
// module id = 1437
// module chunks = 162540808437212